import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter, OnChanges } from "@angular/core";
import { IDropdownItem } from "../components/dropdown.component";
import { IDropdownMultiselect } from "../components/dropdown-multiselect.component";
import { ILanguageModel } from "../models/language.model";
import { CommonService } from "../services/common.service";

@Component({
	selector: "languages",
	template: `<dropdown-multiselect [id]="'languagesSelect'"
					[rows]="8"
					[isLiveSearch]="'false'"
					[dropdownItems]="languagesDropdownItems"
					[model]="languagesDropdown"
					(dropdownChanged)="onLanguagesSelect($event)"></dropdown-multiselect>`
})
export class LanguagesComponent implements OnInit, OnChanges {
	@Input() countryId = 0;

	id: string;
	languagesDropdownItems: IDropdownItem[] = [];
	languagesDropdown: IDropdownMultiselect = { selected: [0] };
	selectedLanguageNameList: Array<string> = [];
	selectedLanguageIdList: Array<string> = [];
	validLanguages: ILanguageModel[] = [];

	@Output() languageChanged: EventEmitter<ILanguageModel[]> = new EventEmitter<ILanguageModel[]>();

	constructor(private commonService: CommonService) { }

	ngOnInit() {
		this.languagesDropdown.buttonText = "Nothing selected";
		this.getLanguages();
	}

	ngOnChanges(changes: SimpleChanges) {
    if (changes["countryId"] && changes["countryId"].currentValue !== changes["countryId"].previousValue) {
			setTimeout(() => {
				this.languagesDropdown.selected = [0];
				this.getLanguages();
			});
		}
	}

  getLanguages() {
    if (!this.countryId || this.countryId <= 0)
      return;

		this.commonService.getLocales(this.countryId || 0).subscribe(result => {
			let languages: IDropdownItem[] = [];
			this.validLanguages = result;
			for (let language of result || []) {
				languages.push({ value: language.id || 0, text: language.name || "" });
			}

			this.languagesDropdownItems = languages;

			if (this.languagesDropdownItems.length === 1 && this.languagesDropdownItems[0].value) {
				this.languagesDropdown.selected = [this.languagesDropdownItems[0].value || 0];
				this.onLanguagesSelect(this.languagesDropdownItems);
			}
		});
	}

	onLanguagesSelect(languages: IDropdownItem[]) {
		let items: ILanguageModel[] = [];
		for (let language of languages) {
			let elem: ILanguageModel[] = this.validLanguages.filter(i => i.id === language.value);
			if (elem) {
				items.push(elem[0]);
			}
		}
		this.languageChanged.emit(items);
	}
}
